import { Box, Typography } from '@mui/material';
import { SCROLLABLE_DIV_ID } from 'components/constants/Constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SearchResults } from 'types/Search';
import SearchListTable from './ListView/SearchListTable';
import { SearchViewProps } from './SearchViewProps';
import { LoadingIndicator } from './shared/LoadingIndicator';

type SearchListViewProps = {
  data: SearchResults;
  setSearchResults: Function;
  handleCompareModeRowClick: Function;
  logItemClick: Function;
  onLoadMore: () => void;
} & SearchViewProps;

const SearchListView = (props: SearchListViewProps) => {
  return props.data.results.length !== 0 ? (
    <InfiniteScroll
      scrollableTarget={SCROLLABLE_DIV_ID}
      dataLength={props.data.results.length}
      next={props.onLoadMore}
      hasMore={props.data.total > props.data.results.length + 1}
      loader={<LoadingIndicator />}
      scrollThreshold={0.8}
      style={{ overflow: 'initial' }}
    >
      <Box
        sx={{
          border: ({ palette }) => `1px solid ${palette.divider}`,
          display: 'flex',
          minHeight: '0',
          flexGrow: 1,
          width: '100%',
          backgroundColor: 'white',
          position: 'relative',
          flexDirection: 'row' // needed to make the product detail panel work
        }}
      >
        <SearchListTable {...props} />
      </Box>
    </InfiniteScroll>
  ) : (
    <Typography variant="h6" align="center">
      No matching {props.data.search?.target.toLowerCase()} found.
    </Typography>
  );
};

export default SearchListView;
